var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNegativeSmile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "negative_smile_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "negative_smile_svg__icon_enjoyment-low",
    "data-name": "icon_enjoyment-low",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 13,
    fill: "#ff6259"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.71,
    cy: 16.9,
    r: 2.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "negative_smile_svg__cls-3",
    d: "M23.71 14.43a2.48 2.48 0 11-2.47 2.47 2.48 2.48 0 012.47-2.47m0-1a3.48 3.48 0 103.48 3.47 3.48 3.48 0 00-3.48-3.47z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.29,
    cy: 16.9,
    r: 2.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "negative_smile_svg__cls-3",
    d: "M16.29 14.43a2.48 2.48 0 11-2.48 2.47 2.48 2.48 0 012.48-2.47m0-1a3.48 3.48 0 103.47 3.47 3.48 3.48 0 00-3.47-3.47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.44 25.94a9.27 9.27 0 0113.12 0 1.23 1.23 0 01-1.74 1.75 6.81 6.81 0 00-9.64 0 1.23 1.23 0 11-1.74-1.75z"
  })), /*#__PURE__*/React.createElement("style", null, ".negative_smile_svg__cls-3{fill:#fff}"))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    width: 40,
    height: 40,
    xlinkHref: "#negative_smile_svg__icon_enjoyment-low"
  })));
}
export default SvgNegativeSmile;